import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';

const TeacherClasses = () => {
  const { user } = useAuth();
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchClasses = async () => {
      try {
        // Fetch teacher profile first
        const profileResponse = await api.get(`/teachers/user/${user?._id}`);
        
        // Fetch classes assigned to this teacher
        const classesResponse = await api.get(`/classes/teacher/${profileResponse.data.data._id}`);
        
        setClasses(classesResponse.data.data);
      } catch (error) {
        console.error('Error fetching classes:', error);
        // Fallback to mock data if API fails
        const mockClasses = [
          {
            id: 1,
            className: 'Grade 10',
            section: 'A',
            subject: 'Mathematics',
            totalStudents: 35,
            period: 'Period 1 (9:00-10:00 AM)',
            room: 'Room 101'
          },
          {
            id: 2,
            className: 'Grade 10',
            section: 'B',
            subject: 'Mathematics',
            totalStudents: 32,
            period: 'Period 3 (11:00-12:00 PM)',
            room: 'Room 102'
          },
          {
            id: 3,
            className: 'Grade 9',
            section: 'A',
            subject: 'Algebra',
            totalStudents: 28,
            period: 'Period 5 (2:00-3:00 PM)',
            room: 'Room 101'
          }
        ];
        setClasses(mockClasses);
      } finally {
        setLoading(false);
      }
    };

    if (user) {
      fetchClasses();
    }
  }, [user]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center py-8">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen py-8">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl font-bold text-gray-800 mb-8">My Classes</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {classes.map((classItem) => (
            <div key={classItem.id} className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition">
              <div className="flex justify-between items-start mb-4">
                <div>
                  <h3 className="text-xl font-semibold text-gray-800">{classItem.className}</h3>
                  <p className="text-gray-600">{classItem.section} Section</p>
                </div>
                <span className="bg-primary text-white px-3 py-1 rounded-full text-sm">
                  {classItem.subject}
                </span>
              </div>
              
              <div className="space-y-2 mb-4">
                <p className="flex justify-between">
                  <span className="text-gray-600">Total Students:</span>
                  <span className="font-medium">{classItem.totalStudents}</span>
                </p>
                <p className="flex justify-between">
                  <span className="text-gray-600">Period:</span>
                  <span className="font-medium">{classItem.period}</span>
                </p>
                <p className="flex justify-between">
                  <span className="text-gray-600">Room:</span>
                  <span className="font-medium">{classItem.room}</span>
                </p>
              </div>
              
              <div className="flex space-x-2">
                <button className="flex-1 bg-primary text-white py-2 px-4 rounded hover:bg-blue-700 transition text-sm">
                  Take Attendance
                </button>
                <button className="flex-1 bg-gray-200 text-gray-800 py-2 px-4 rounded hover:bg-gray-300 transition text-sm">
                  Enter Marks
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 bg-white rounded-lg shadow-md p-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">Class Schedule</h2>
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Class</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Section</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Subject</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Students</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Period</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {classes.map((classItem) => (
                  <tr key={classItem.id}>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{classItem.className}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{classItem.section}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{classItem.subject}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{classItem.totalStudents}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{classItem.period}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                      <button className="text-primary hover:text-blue-700 mr-4">Attendance</button>
                      <button className="text-green-600 hover:text-green-800 mr-4">Marks</button>
                      <button className="text-purple-600 hover:text-purple-800">Materials</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeacherClasses;